﻿import { CommonFlags as c, DefaultColumns, EntityColumn, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { Ciudades } from "../Ciudades/Ciudades";
import { Paises } from "../Paises";
import { Provincias } from "../Provincias/Provincias";

const columns = () =>
(
    {
        c_pais_id: new EntityColumn<string>({ name: 'c_pais_id', type: 'char', length: 20, flags: c.PK, prompt: 'Pais Id' }),
        c_provincia_id: new EntityColumn<string>({ name: 'c_provincia_id', type: 'char', length: 20, flags: c.PK, prompt: 'Provincia Id' }),
        c_ciudad_id: new EntityColumn<string>({ name: 'c_ciudad_id', type: 'char', length: 20, flags: c.PK, prompt: 'Ciudad Id' }),
        c_localidad_id: new EntityColumn<string>({ name: 'c_localidad_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Localidad Id' }),
        vc_localidad_nombre: new EntityColumn<string>({ name: 'vc_localidad_nombre', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Localidad Nombre' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        locl_brwStandard: { name: 'locl_brwStandard', keyMappings: { c_localidad_id: 0 } }
    }
)

const lookups = () =>
(
    {
        'Paises': {
            name: 'Paises',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Paises(client, parentKeys)
        },
        'Provincias': {
            name: 'Provincias',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Provincias(client, parentKeys)
        },
        'Ciudades': {
            name: 'Ciudades',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Ciudades(client, parentKeys)
        }
    }
)

export class LocalidadesDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();

    constructor() {
        super('Localidades');
    }
}